'use client';

import { LoginToViewOverlay } from '@/modules/players/v2/tabs/components/login-to-view-overlay';
import { MyGear } from '@/modules/players/v3/components/player-pages/dashboard/my-gear/my-gear';
import { PublicMyGearPlaceholder } from '@/modules/players/v3/components/player-pages/my-gear/public/public-my-gear-placeholder';
import { useAuthorizeDashboard } from '@/modules/players/v3/hooks/use-authorize-dashboard';
import { User } from '@/types/players.types';

interface PublicMyGearProps {
  editPlayer: User;
  isOwnProfile: boolean;
  isLoggedIn: boolean;
  isWebview?: boolean;
}

export const PublicMyGear = ({
  editPlayer,
  isOwnProfile,
  isLoggedIn,
  isWebview,
}: PublicMyGearProps) => {
  const showOwnerActions = useAuthorizeDashboard(isOwnProfile);

  if (!isLoggedIn) {
    return (
      <LoginToViewOverlay>
        <PublicMyGearPlaceholder />
      </LoginToViewOverlay>
    );
  }

  return (
    <MyGear
      editPlayer={editPlayer}
      isWebview={isWebview}
      showOwnerActions={showOwnerActions}
      showPickleballCentralDeals
    />
  );
};
